import React from "react";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";

import { EMPTY_VALUE_REGEX } from "components/RichTextEditor/constants";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Text from "components/Text";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

interface IPrintableRisksAndMitigants {
  section: IMemoSection;
}

const PrintableRisksAndMitigants = ({
  section,
}: IPrintableRisksAndMitigants) => (
  <>
    <SectionHeader label={section.title} />
    <SectionContent>
      <Stack spacing={2}>
        {_.isEmpty(section.risks) ? (
          <Text sx={{ color: colors.gray60 }}>No items added yet...</Text>
        ) : (
          section.risks.map((risk) => (
            <React.Fragment key={risk.id}>
              <SectionHeader label={risk.title} />
              {EMPTY_VALUE_REGEX.test(risk.description) ||
              risk.description === "" ? (
                <Text
                  variant="text2"
                  sx={{
                    color: colors.gray60,
                    padding: theme.spacing(0, 2),
                  }}
                >
                  No content yet..
                </Text>
              ) : (
                <Text
                  variant="text2"
                  sx={{
                    padding: theme.spacing(0, 2),
                    "*": { lineHeight: "140% !important" },
                    table: {
                      width: "100%",
                    },
                    "table, th, td, tr": {
                      borderCollapse: "collapse",
                      border: "1px solid black !important",
                    },
                  }}
                >
                  <SanitizeHtml html={risk.description} />
                </Text>
              )}
            </React.Fragment>
          ))
        )}
      </Stack>
    </SectionContent>
  </>
);

export default PrintableRisksAndMitigants;
